const abbrev = ['k', 'M', 'B'];
const round = (n: number, precision: number) => {
  const precPow = Math.pow(10, precision);
  return Math.round(n * precPow) / precPow;
};
export const numberAbbreviator = (num: number, decimals = 0): string => {
  let base = Math.floor(Math.log(Math.abs(num)) / Math.log(1000));
  const suffix = abbrev[Math.min(2, base - 1)];
  base = abbrev.indexOf(suffix) + 1;
  return suffix ? `${round(num / Math.pow(1000, base), decimals)}${suffix}` : num.toString();
};
